import { createValidationDataObject } from "@/utils/form-validation";

export const webPaymentDeliveryValidator = {
  address: (str) => {
    if (!str) {
      return createValidationDataObject(false, "Address is required");
    }

    return createValidationDataObject();
  },
  country: (str) => {
    if (!str) {
      return createValidationDataObject(false, "Country is required");
    }

    return createValidationDataObject();
  },
  state: (str) => {
    if (!str) {
      return createValidationDataObject(false, "State is required");
    }

    return createValidationDataObject();
  },
  locality: (str) => {
    if (!str) {
      return createValidationDataObject(false, "City is required");
    }

    return createValidationDataObject();
  },
  name: (str) => {
    if (!str) {
      return createValidationDataObject(false, "Name is required");
    }
    return createValidationDataObject();
  },
  sublocality: () => {
    return createValidationDataObject();
  },
  apartment: () => {
    return createValidationDataObject();
  },
  postal: (str) => {
    if (!str) {
      return createValidationDataObject(false, "Postcode is required");
    }
    return createValidationDataObject();
  },
  phoneNumber: (str) => {
    if (!str) {
      return createValidationDataObject(false, "Phone number is required");
    }

    return createValidationDataObject();
  },
};
